import { Link, useLocation } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaEnvelope,
  FaPhone,
  FaCircle
} from 'react-icons/fa';
import './footer.css';

function Footer() {
  const location = useLocation();
  const year = new Date().getFullYear();

  const hiddenPaths = [
    '/loginVpStore',
    '/registerVpStore',
    '/recuperar-password',
    '/reset-password',
    '/checkout',
    '/checkout/payment-result'
  ];

  if (hiddenPaths.includes(location.pathname)) return null;

  return (
    <footer className="footer">
      <div className="footer-glow footer-glow-left" aria-hidden="true"></div>
      <div className="footer-glow footer-glow-right" aria-hidden="true"></div>

      <Container fluid className="footer-shell">
        <Row className="footer-main-row">
          <Col lg={3} md={6} className="mb-3 d-flex flex-column footer-logo-col">
            <div className="footer-logo-panel mb-2">
              <img
                src="/images/VPA.png"
                alt="Vpac Logo"
                className="footer-logo"
              />
            </div>
            <span className="footer-submark">Submarca de Red Package S.A.S.</span>
          </Col>

          <Col lg={3} md={6} className="mb-3 d-flex flex-column footer-brand-col">
            <span className="footer-kicker mb-2">VINTAGE PRO AUDIO</span>
            <h4 className="footer-brand-title mb-2">Audio con caracter, historia y precision</h4>
            <p className="footer-description mb-0">
              Revive el sonido clasico con equipos de audio profesional vintage, seleccionados para apasionados del audio en Colombia.
            </p>
          </Col>

          <Col lg={3} md={6} className="mb-3 d-flex flex-column footer-links-col">
            <h5 className="footer-title mb-3">Enlaces rapidos</h5>
            <ul className="footer-links list-unstyled">
              <li><Link to="/about"><FaCircle className="me-2 bullet-icon" size={6} />Quienes Somos</Link></li>
              <li><Link to="/tienda"><FaCircle className="me-2 bullet-icon" size={6} />Tienda</Link></li>
              <li><Link to="/mi-cuenta"><FaCircle className="me-2 bullet-icon" size={6} />Mi Cuenta</Link></li>
              <li><Link to="/contacto"><FaCircle className="me-2 bullet-icon" size={6} />Contacto</Link></li>
            </ul>
          </Col>

          <Col lg={3} md={6} className="mb-3 d-flex flex-column footer-social-col">
            <h5 className="footer-title mb-3">Conecta con nosotros</h5>
            <div className="footer-social mb-3">
              <a href="https://www.facebook.com/RedPackage4.0/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com/redpackage/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://www.linkedin.com/company/redpackagesas/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
              <a href="https://wa.me/573012201583" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
            </div>

            <div className="footer-contact">
              <p><FaEnvelope className="me-2" /> redpackage@outlook.com</p>
              <p><FaEnvelope className="me-2" /> redpackagesas@gmail.com</p>
              <p><FaPhone className="me-2" /> +57 301 220 1583</p>
            </div>
          </Col>
        </Row>

        <hr className="footer-divider" />

        <div className="footer-bottom text-center">
          <p className="footer-bottom-title mb-1">Vintage Pro Audio Colombia {year} &copy;</p>
          <p className="mb-1 small">Una submarca de Red Package S.A.S. dedicada al audio profesional.</p>
          <p className="mb-0 small text-muted">Todos los derechos reservados.</p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
